import { TaskStateChangeModal } from "components/Task/TaskStateChangeModal";
import { BooksGlobalStatusUpdate } from "hooks/useBooksGlobalStatusUpdate";

export const BooksStatusChangeModal = ({
  statusUpdate,
}: {
  statusUpdate: BooksGlobalStatusUpdate;
}) => {
  if (!statusUpdate.pendingStatus) return null;

  return (
    <TaskStateChangeModal
      isOpen
      onClose={statusUpdate.cancelStatusChange}
      onConfirm={statusUpdate.confirmStatusChange}
      targetLabel={statusUpdate.pendingStatus.name}
      isOnHold={false}
      isLoading={statusUpdate.isUpdating}
    />
  );
};
